import React from "react";
import "./css/AboutUs.css"; // Reusing the shared CSS
import pictureOne from "./assets/picOne.png";

const VerificationCalibration = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header verification-header">
        <div className="overlay">
          <h1 className="page-title">Verification and Calibration</h1>
          <p className="subtitle">
            Ensuring accuracy, reliability, and compliance of measurements across Malawi.
          </p>
        </div>
      </section>

      {/* === Introduction Section === */}
      <section className="intro-section">
        <div className="intro-card">
          <h2>About Verification and Calibration Services</h2>
          <p>
            The Malawi Bureau of Standards (MBS) provides verification and calibration services to ensure 
            that measuring instruments, laboratory equipment, and industrial devices produce accurate 
            and reliable results. These services help maintain conformity to national and international 
            standards.
          </p>
        </div>

        <div className="intro-card">
          <h2>Our Commitment</h2>
          <p>
            MBS ensures that instruments and measurement systems used in trade, industry, and laboratories 
            are precise, calibrated, and traceable to international measurement standards. This promotes 
            fair trade, product quality, and consumer confidence.
          </p>
        </div>
      </section>

      {/* === Core Services Section === */}
      <section className="functions-section">
        <h2>Core Verification and Calibration Services</h2>
        <ul>
          <li>
            <strong>Calibration of Weighing Instruments:</strong> Ensuring commercial scales, laboratory balances, 
            and industrial weighing systems are accurate.
          </li>
          <li>
            <strong>Verification of Measuring Devices:</strong> Checking meters, gauges, thermometers, and pressure 
            instruments for compliance with standards.
          </li>
          <li>
            <strong>Traceability to International Standards:</strong> All calibrations are traceable to SI units, 
            ensuring reliability across borders.
          </li>
          <li>
            <strong>Certification of Measurement Equipment:</strong> Issuing certificates for instruments that meet 
            prescribed accuracy requirements.
          </li>
          <li>
            <strong>Technical Support:</strong> Providing guidance to businesses and laboratories on measurement best practices.
          </li>
        </ul>
      </section>

      {/* === Background and Mandate === */}
      <section className="background-section">
        <div className="text-content">
          <h2>Background</h2>
          <p>
            The Malawi Bureau of Standards (MBS) operates verification and calibration services under its statutory 
            mandate to promote metrology, standardization, and quality assurance in Malawi. These services are 
            crucial for trade, industry, and scientific research.
          </p>

          <h2>Mandate</h2>
          <p>
            To ensure that all measuring instruments, devices, and systems used in commerce, industry, and laboratories 
            are accurate, reliable, and compliant with national and international measurement standards.
          </p>
        </div>

        <div className="image-content">
          <img src={pictureOne} alt="Verification and Calibration Services" />
        </div>
      </section>

      {/* === Benefits Section === */}
      <section className="benefits-section">
        <h2>Benefits of Verification and Calibration</h2>
        <ul>
          <li>Enhances accuracy and reliability of measurements in industry and commerce.</li>
          <li>Supports fair trade and consumer protection.</li>
          <li>Ensures compliance with national and international standards.</li>
          <li>Improves operational efficiency and product quality.</li>
          <li>Facilitates acceptance of goods and measurements in international trade.</li>
        </ul>
      </section>
    </div>
  );
};

export default VerificationCalibration;
